import { type ButtonSize } from "antd/lib/button";
import { Component } from "react";

import { dispatchTracking, type ITrackingData } from "utilities/analytics/analytics";

import ReadMorePresentational from "commonComponents/utilities/ReadMore/ReadMorePresentational";

import "./ReadMore.less";

interface IReadMoreProps {
    entityId?: number;
    numberOfLines: number;
    lineHeight?: number;
    "data-testid"?: string;
    size: ButtonSize;
    children: React.ReactNode;
    trackingData?: Partial<ITrackingData>;
    onScrollBackToButton?: () => void;
}

interface IReadMoreState {
    showingMore: boolean;
}

export default class ReadMore extends Component<IReadMoreProps, IReadMoreState> {
    static defaultProps = {
        size: "default",
    };

    state: Readonly<IReadMoreState> = {
        showingMore: false,
    };

    private toggleShowMore = (showingMore: boolean) => {
        if (this.props.trackingData) {
            dispatchTracking(this.props.trackingData);
        }

        this.setState({ showingMore });
    };

    render = () => {
        const { showingMore } = this.state;
        return (
            <ReadMorePresentational
                showingMore={showingMore}
                onShowingMoreToggle={this.toggleShowMore}
                {...this.props}
            />
        );
    };
}
